export default __webpack_public_path__ + "static/nirapon-logo-278ff299f196562947ffe5e907df2c63.jpg";